var Base = require('_js/base'),
  ko = require('knockout');

var model = function(params) {
  this.params = params;
};

function InstructorList() {
  this.init();
}

InstructorList.prototype = new Base();

InstructorList.prototype.init = function() {
  $('[data-instructors-list]').each(function() {
    ko.applyBindings(new model($(this).data('instructors-list')), this);
  });
};
module.exports = InstructorList;
